import React, { useContext } from 'react';

import { Box, Flex, StyledOcticon, LabelGroup, BorderBox, Timeline, Avatar, Label } from '@primer/components'
import { GitCommit, Eye, Info } from '@primer/octicons-react'
import ReactDiffViewer from 'react-diff-viewer';
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';

import { useProduct } from '../../hooks/useProduct'
import { CorpusContext } from '../../hooks/useCorpus'

import Advice from '../../components/Advice'
import { countMessageGroups } from '../../helpers'
import IssueCategoryAnalysis from './IssueCategoryAnalysis'
import IssueImpactAnalysis from './IssueImpactAnalysis'
import DjangoBugs from './DjangoBugs'
import DjangoVersionAnalysis from './DjangoVersionAnalysis'
import MarketplaceAdvert from './MarketplaceAdvert'
import PullRequestFile from './PullRequestFile'


export default function({
  messages, djangoVersionDetails, report, checkProviders, owner, repository, branch
}) {
    const { corpus } = useContext(CorpusContext)
    const messageGroupCounts = countMessageGroups(messages, corpus)
    const showDjangoAnaysis = checkProviders.includes('django') && Object.keys(djangoVersionDetails).length > 0
    const showDjangoBugs = checkProviders.includes('django') && djangoVersionDetails.newestAvailableMinorVersion
    return (
      <>
        <Box className="d-md-flex">
          <Box className="col-md-3 mr-md-4 mb-2">
            { 
              showDjangoAnaysis && <DjangoVersionAnalysis
                {...djangoVersionDetails}
                owner={owner}
                repository={repository}
                branch={branch}
              />
            }
            <IssueImpactAnalysis {...messageGroupCounts} />
            <IssueCategoryAnalysis {...messageGroupCounts} />
          </Box>
          <BorderBox className="col-md-9">
            <PullRequestTimeline report={report} />
            <MarketplaceAdvert />
          </BorderBox>
        </Box>
        { 
          showDjangoBugs && <DjangoBugs
            versionFrom={djangoVersionDetails.specifierResolves}
            versionTo={djangoVersionDetails.newestAvailableMinorVersion}
            specifierResolves={djangoVersionDetails.specifierResolves}
            newestAvailableMinorVersion={djangoVersionDetails.newestAvailableMinorVersion}
          />
        }
      </>
    )
}



const PullRequestTimeline = function(props) {
  const { corpus } = useContext(CorpusContext)
  const productDetails = useProduct()

  const botName = productDetails.id === 'djangodoctor' ? 'django-doctor' : 'code-review-doctor'

  return (
    <Box style={{background: "white", borderRadius: 6}} className="pr-4 pl-2  ml-md-0 mr-md-0 ml-2 mr-2">
      <Timeline>
        <Timeline.Item className={"pb-0"}>
          <Timeline.Badge>
            <StyledOcticon icon={Eye} />
          </Timeline.Badge>
          <Timeline.Body>
            <Avatar src="/favicon.png" size={32} className="mr-2 text-grey" />
            <strong className="pr-2"><a href={productDetails.gitHubMarketplaceLink} rel="noopener noreferrer" target="_blank" style={{color: "black"}}>{botName}</a></strong>
            <Label variant="small" sx={{border: "1px solid grey", color: "grey", backgroundColor: "white"}}>bot</Label>
            <span className="pl-2">would suggest these changes <a href={productDetails.gitHubMarketplaceLink} rel="noopener noreferrer" target="_blank">right inside your pull requests</a> on GitHub.</span>
          </Timeline.Body>
        </Timeline.Item>
        {
          props.report.map(([path, messages], i) => {
            const child = (
              <Timeline.Item className={"pb-0"} key={`timeline-${path}`}>
                <Timeline.Body className="ml-4">
                  <Box style={{borderBottomRightRadius: 0, borderTopLeftRadius: 6}}>
                    <PullRequestFile path={path} messages={messages} />
                  </Box>
                </Timeline.Body>
              </Timeline.Item>
            )
            return i > 5 ? <LazyLoad height="545px">{child}</LazyLoad> : child
          })
        }
      </Timeline>
    </Box>
  )
}
